import React, { Fragment, useState, useEffect, useContext } from "react";
import Head from "../../Head";
import BotonesOpciones from "./BotonesOpciones";
import { Context } from "../../../store/AppContext";

const VistaInicialDtCobranza = () => {
	const { store, actions } = useContext(Context);
	const titulosHead = [
		"Bienvenido al Servicio de Direccion Tributaria - Bodega",
		"Por favor, selecciona que deseas realizar:",
	];
	const [animar, setAnimar] = useState(false);

	//Animacion
	useEffect(() => {
		setAnimar(true);
	}, []);

	return (
		<Fragment>
			<Head contenido={titulosHead} />
			<div className='row'>
				<div className='column'>
					<BotonesOpciones
						animar={animar}
					/>
				</div>
			</div>
		</Fragment>
	);
};

export default VistaInicialDtCobranza;
